var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 3.23132C4.94303 3.23132 2.17081 4.90382 0.125192 7.6204C-0.0417306 7.84296 -0.0417306 8.1539 0.125192 8.37646C2.17081 11.0963 4.94303 12.7688 8 12.7688C11.057 12.7688 13.8292 11.0963 15.8748 8.37973C16.0417 8.15717 16.0417 7.84624 15.8748 7.62367C13.8292 4.90382 11.057 3.23132 8 3.23132ZM8.21929 11.3582C6.19004 11.4858 4.51427 9.8133 4.64191 7.78078C4.74665 6.10501 6.10494 4.74672 7.78071 4.64198C9.80996 4.51433 11.4857 6.18683 11.3581 8.21936C11.2501 9.89185 9.89179 11.2501 8.21929 11.3582ZM8.11783 9.80675C7.02465 9.87549 6.12131 8.97542 6.19331 7.88224C6.24895 6.97889 6.9821 6.24902 7.88545 6.1901C8.97862 6.12137 9.88197 7.02144 9.80996 8.11462C9.75105 9.02124 9.0179 9.75111 8.11783 9.80675Z",
    fill: "#737A91",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.afa50cf04b90d7bee208641dba1c28f8.svg";
export { ForwardRef as ReactComponent };